export function copyToClipboard(text: string) {
  if (!text) return;
  return navigator.clipboard.writeText(text);
}
